export default __webpack_public_path__ + "static/icon-32-4-91ba8156c78bf31b6d8acdc77b2e6a60.png";